import React from 'react';

export default function EnterpriseRoleBadge({ role, className = '' }) {
  if (!role?.name) {
    return (
      <span
        className={`inline-flex rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground ${className}`.trim()}
      >
        —
      </span>
    );
  }
  const color = role.colorHex || '#6366f1';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`.trim()}
      style={{
        backgroundColor: `${color}20`,
        color,
      }}
    >
      <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: color }} aria-hidden />
      {role.name}
    </span>
  );
}
